/* The first-artwork card's rules (site-furniture spec §5.1). It appears on the second page view of a visit, or once
   half the page has been scrolled, whichever comes first, and never on arrival. It never appears once the cart has
   something in it, or for 30 days after it's closed or its code is copied. If storage can't be read, it doesn't
   appear at all. While our cookie card (gr-consent) or Shopify's own banner is open it waits, so a first visit sees
   one thing at a time.
   It steps aside when the cart drawer opens after an add. It never takes the focus; Escape closes it.
   Its words come from gr-popup's data-gr-i18n="popup" block, with English as the fallback. */
(() => {
  const card = document.querySelector('[data-gr-popup]');
  if (!card || window.grPopup) return;
  window.grPopup = true;
  const KEY = 'gr_popup_dismissed', VIEWS = 'gr_popup_views', DAYS_30 = 30 * 864e5;
  const delay = Number(card.dataset.delay ?? 3000);   // into the second page view
  // Liquid's t filter HTML-escapes what it outputs ("&#39;"): back to plain text for textContent
  const ENTITIES = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&#x27;': "'" };
  const decode = (s) => s.replace(/&(?:amp|lt|gt|quot|#39|#x27);/g, (m) => ENTITIES[m]);
  const T = { copied: 'Copied', selected: 'Selected' };
  try {
    const got = JSON.parse(document.querySelector('[data-gr-i18n="popup"]')?.textContent || '{}');
    Object.keys(got).forEach((k) => { if (typeof got[k] === 'string') T[k] = decode(got[k]); });
  } catch (e) { /* English */ }
  let views;
  try {
    const at = Number(localStorage.getItem(KEY) || 0);
    if (at && Date.now() - at < DAYS_30) return;
    views = Number(sessionStorage.getItem(VIEWS) || 0) + 1;
    sessionStorage.setItem(VIEWS, String(views));
  } catch (e) {
    return;
  }
  const dismiss = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* shown this visit only */ } };
  let asked = false, closed = false;                    // closed: shut, or stepped aside for the cart drawer
  const show = async () => {
    if (asked) return;
    asked = true;
    window.removeEventListener('scroll', onScroll);
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = res.ok ? await res.json() : null;
      if (!cart || typeof cart.item_count !== 'number' || cart.item_count > 0) return;
    } catch (e) {
      return;
    }
    const consent = () => {                            // our cookie card or its choices, or Shopify's own banner
      if (document.querySelector('[data-gr-consent]:not([hidden]), [data-gr-consent-sheet][open]')) return true;
      const b = document.getElementById('shopify-pc__banner');
      return !!b && getComputedStyle(b).display !== 'none';
    };
    while (consent()) await new Promise((r) => setTimeout(r, 500));
    if (closed) return;
    card.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => card.classList.add('is-open')));
  };
  const hide = () => {
    closed = true;
    card.classList.remove('is-open');
    card.hidden = true;
    document.removeEventListener('keydown', onKey);
  };
  const onScroll = () => {
    const room = document.documentElement.scrollHeight - window.innerHeight;
    if (room > 0 && window.scrollY / room >= 0.5) show();
  };
  const onKey = (e) => { if (e.key === 'Escape' && !card.hidden) { dismiss(); hide(); } };
  card.querySelector('[data-gr-popup-close]').addEventListener('click', () => { dismiss(); hide(); });
  card.querySelector('[data-gr-popup-copy]').addEventListener('click', async (e) => {
    const button = e.currentTarget;
    dismiss();
    try {
      await navigator.clipboard.writeText(button.dataset.code);
      button.textContent = T.copied;
    } catch (err) {
      const range = document.createRange();
      range.selectNodeContents(card.querySelector('.gr-popup__code span'));
      getSelection().removeAllRanges();
      getSelection().addRange(range);
      button.textContent = T.selected;
    }
  });
  document.addEventListener('keydown', onKey);
  document.addEventListener('opened', (e) => {          // the theme's drawer or cart notice: the cart has something now
    if (e.target instanceof Element && /cart/i.test(`${e.target.id} ${e.target.tagName}`)) { asked = true; hide(); }
  }, true);
  if (views >= 2) setTimeout(show, delay);
  else window.addEventListener('scroll', onScroll, { passive: true });
})();
